import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import FilterPanel from "../components/panels/FilterPanel";
import ProductDistributionCountry from "./views/ProductDistributionCountry";
import ProductDistributionOverview from "./views/ProductDistributionOverview";
import {getCountryFromCode} from "../lib/CountriesAndStates";
import {List, Map, Range} from "immutable";

function yearFilterOptions() {
  let startYear = 2018;
  let endYear = new Date(Date.now()).getFullYear();
  return Range(startYear, endYear+1).map((year) => Map({id: year, label: String(year)}));
}

class ProductDistributionPage extends Component {

  constructor(props) {
    super(props);
    this.handleBack = this.handleBack.bind(this);
    this.state = {
      yearFilter: new Date().getFullYear()
    }
  }
  
  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Product Distribution";
    if (page === "country") {
      title = `Product Distribution / ${this.props.params.countryCode.toUpperCase()} / ${this.props.params.year}`;
    }

    return (
      <div className="ShippingPage ProductDistributionPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} backButton={page === "country"} onBack={this.handleBack}/>
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          {panels}
        </div>
      </div>
    );
  }

  renderView(page) {
    switch(page) {
      case "country": 
        return <ProductDistributionCountry
                key="ProductDistributionCountry"
                countryCode={this.props.params.countryCode.toUpperCase()}
                countryName={getCountryFromCode(this.props.params.countryCode.toUpperCase()).get("name")}
                year={parseInt(this.props.params.year, 10)}
                />
      default: 
        return <ProductDistributionOverview
                key="ProductDistributionOverview"
                year={this.state.yearFilter}
                />
    }
  }


  renderPanels(page) {
    switch(page) {
      case "country":
        return this.buildPanels(List(["countryYearFilter"]));

      default:
        return this.buildPanels(List(["yearFilter"]));
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case "yearFilter":
        return <FilterPanel
          key="yearFilter"
          title="Year Filter"
          expanded={true}
          options={yearFilterOptions()}
          onClick={this.handleSetYearFilter.bind(this)}
          filter={this.state.yearFilter}
          />  

      case "countryYearFilter":
        return <FilterPanel
          key="countryYearFilter"
          title="Year Filter"
          expanded={true}
          options={yearFilterOptions()}
          onClick={this.handleSetYearFilterFromCountry.bind(this)}
          filter={parseInt(this.props.params.year, 10)}
          />  
                      
      default:
        return null;
    }
  }

  handleSetYearFilter(item) {
    this.setState({
      yearFilter: item.get("id")
    });
  }    

  handleSetYearFilterFromCountry(item) {
    this.setState({
      yearFilter: item.get("id")
    });
    this.props.router.push(`/shipping/product-distribution/${this.props.params.countryCode}/${item.get("id")}`);
  }    

  handleBack() {
    this.props.router.push(`/shipping/product-distribution`);
  }    

}

export default ProductDistributionPage;